import { Row } from "~/components/elements/grid/Row";
import { UiImage } from "~/components/elements/UiImage";
import images from "~/assets/img";
import { appConfig } from "~/config";
import React from "react";
import { UiLink } from "~/components/elements/index";

export function Logo({ imgProps, containerProps, height = "2.125rem", textProps, displayName = true }: any) {
  return (
    <Row align="center" _hover={{ cursor: "pointer", textDecoration: "none" }} {...containerProps}>
      <UiLink
        href={appConfig.homepage}
        onClick={() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      >
        <UiImage src={images.logoNName} height={height} objectFit="cover" mr={2} {...imgProps} />
      </UiLink>
      {/* {displayName && ( */}
      {/*  <UiLink */}
      {/*    href={appConfig.homepage} */}
      {/*    onClick={() => { */}
      {/*      window.scrollTo({ top: 0, behavior: "smooth" }); */}
      {/*    }} */}
      {/*    _hover={{ textDecoration: "none" }} */}
      {/*  > */}
      {/*    <UiText fontWeight="bold" fontSize="2xl" {...textProps}> */}
      {/*      {appConfig.siteName} */}
      {/*    </UiText> */}
      {/*  </UiLink> */}
      {/* )} */}
    </Row>
  );
}
